import { createFileRoute, redirect } from '@tanstack/react-router'

import { ConnectedAppsPage } from '@/features/account/pages/connected-apps-page'
import { isFeatureEnabled } from '@/lib/feature-flags'

/** Connected apps — personal access tokens for the Bru connector (`/v2/mcp`). Absent while the flag is off. */
export const Route = createFileRoute('/_ws/w/$workspaceId/connected-apps')({
  // The flag is environment-wide (it ignores the email), so no signed-in user is needed here.
  beforeLoad: ({ params }) => {
    if (!isFeatureEnabled('connectedApps', null)) {
      throw redirect({ to: '/w/$workspaceId/overview', params: { workspaceId: params.workspaceId } })
    }
  },
  component: ConnectedAppsPage,
})
